import * as React from "react";
const SvgFiRrSwipeUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-swipe-up_svg__a)">
      <path
        fill="#062147"
        d="m20.085 10.327-5.084-1.129V3.107c0-1.516-1.076-2.835-2.503-3.067a3.01 3.01 0 0 0-2.439.674A3 3 0 0 0 9.001 3v11.565l-.955-.758a3 3 0 0 0-4.236.144 3 3 0 0 0 .13 4.23l3.71 3.577a7.96 7.96 0 0 0 5.552 2.241H19c2.757 0 5-2.243 5-5v-3.791a4.97 4.97 0 0 0-3.915-4.881M22 19c0 1.654-1.346 3-3 3h-5.798a5.97 5.97 0 0 1-4.164-1.681l-3.72-3.587a1.004 1.004 0 0 1-.048-1.416.97.97 0 0 1 .711-.309c.26 0 .53.102.758.312l2.637 2.1A1 1 0 0 0 11 16.637V3a1.002 1.002 0 0 1 1.175-.986c.462.075.825.555.825 1.093V10c0 .469.326.875.783.977l5.868 1.304A2.98 2.98 0 0 1 22 15.21v3.791zM3 9V2.871L1.707 4.164A.999.999 0 1 1 .293 2.75L2.367.677a2.3 2.3 0 0 1 1.62-.674Q3.992.002 4 0q.008.002.014.003a2.3 2.3 0 0 1 1.62.674L7.708 2.75a.999.999 0 1 1-1.414 1.414L5.001 2.871V9a1 1 0 1 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-swipe-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSwipeUp;
